import React, { useEffect } from 'react';
import PageMeta from '../components/PageMeta';
import { CheckCircle2, Sparkles } from 'lucide-react';
import AdmissionEnrollment from '../components/AdmissionEnrollment';
import SiteFooter from '../components/SiteFooter';
import MobileCTABar from '../components/MobileCTABar';
import SiteHeader from '../components/SiteHeader';

const BookDemoPage = () => {
  useEffect(() => { document.title = 'Book a Free Demo · AI School For All'; }, []);

  return (
    <div className="min-h-screen bg-white text-slate-900" data-testid="book-demo-page">
      <PageMeta
        title="Book a Free Demo Class | AI School for All"
        description="Book your free demo class at AI School for All. Experience our teaching before you enroll."
        path="/book-demo"
      />
      <SiteHeader ctaLabel="Enroll Now" ctaTo="/book-demo" />

      {/* Hero */}
      <section className="py-16 px-6 bg-gradient-to-br from-violet-50 via-white to-amber-50 relative overflow-hidden">
        <div className="absolute -top-20 -right-20 w-[480px] h-[480px] rounded-full bg-violet-200/40 blur-[140px]"></div>
        <div className="absolute -bottom-32 -left-32 w-[480px] h-[480px] rounded-full bg-amber-200/40 blur-[140px]"></div>

        <div className="container mx-auto max-w-5xl text-center relative z-10">
          <div className="inline-flex items-center gap-2 bg-violet-100 text-violet-700 rounded-full px-4 py-1.5 mb-5">
            <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse"></span>
            <span className="text-xs font-bold uppercase tracking-widest">Admissions Open · Filling Fast</span>
          </div>
          <h1 className="text-4xl md:text-6xl font-black leading-tight mb-5">
            Book a Free <span className="text-transparent bg-clip-text bg-gradient-to-r from-violet-600 to-amber-600">Demo Session</span>
          </h1>
          <p className="text-lg md:text-xl text-slate-600 max-w-2xl mx-auto mb-8">
            Choose your course, pick a date &amp; time that works for you. A senior counselor will walk you through the curriculum, projects and career outcomes — no payment, no obligation.
          </p>

          <div className="flex flex-wrap items-center justify-center gap-4 text-sm text-slate-600">
            {['100% Free', 'Live 1-on-1 with industry mentor', 'Calendar confirmation by email'].map((t) => (
              <span key={t} className="inline-flex items-center gap-1.5 bg-white border border-slate-200 rounded-full px-3 py-1.5 shadow-sm">
                <CheckCircle2 className="w-4 h-4 text-emerald-600" /> {t}
              </span>
            ))}
          </div>
        </div>
      </section>

      {/* Booking form (shared AdmissionEnrollment component) */}
      <AdmissionEnrollment courseName="Not Sure Yet" theme="violet" source="book-demo-page" />
      <MobileCTABar courseName="Book Demo" />

      <SiteFooter accent="violet" />
    </div>
  );
};

export default BookDemoPage;
